import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantDocument } from '../mutations/createParticipantDocument.mutation';
import type {
  CreateParticipantDocumentMutation,
  CreateParticipantDocumentMutationVariables,
} from '../types';

export const useCreateParticipantDocumentMutation = (
  options?: MutationOptions<
    CreateParticipantDocumentMutation,
    CreateParticipantDocumentMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantDocument), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
